// Example of how to use the API client in your components

import apiClient from '@/lib/apiClient';

// Login request
export const login = async (email: string, password: string) => {
  try {
    const response = await apiClient.post('/auth/login', { email, password });
    return response.data;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};

// Registration request
export const register = async (firstName: string, lastName: string, email: string, password: string, isAgency: boolean) => {
  try {
    const response = await apiClient.post('/auth/register', { firstName, lastName, email, password, isAgency });
    return response.data;
  } catch (error) {
    console.error('Error registering:', error);
    throw error;
  }
};

// GET request example
export const fetchUserProfile = async () => {
  try {
    const response = await apiClient.get('/user/profile');
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

// POST request example
export const createPost = async (postData: { title: string; content: string }) => {
  try {
    const response = await apiClient.post('/posts', postData);
    return response.data;
  } catch (error) {
    console.error('Error creating post:', error);
    throw error;
  }
};

// PUT request example
export const updateUser = async (userId: string, userData: Record<string, unknown>) => {
  try {
    const response = await apiClient.put(`/users/${userId}`, userData);
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

// DELETE request example
export const deletePost = async (postId: string) => {
  try {
    const response = await apiClient.delete(`/posts/${postId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting post:', error);
    throw error;
  }
};

// Create Content for a Domain
export const createDomainContent = async (domainId: string, prompts: string[], sources: string[], mentionCompetitors: boolean = true, articleType: string = 'comparative', language: string = 'English') => {
  try {
    const response = await apiClient.post(`/v1/domains/${domainId}/contents/create`, {
      prompts,
      sources,
      mention_competitors: mentionCompetitors,
      article_type: articleType,
      language,
    });
    return response.data;
  } catch (error) {
    console.error('Error creating domain content:', error);
    throw error;
  }
};
// Poll job status — returns { status, step, error }
export const getJobStatus = async (jobId: string): Promise<{ status: string; step: number; error?: string }> => {
  const response = await apiClient.get(`/v1/jobs/${jobId}`);
  return response.data;
};